import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import useDynamicComponent from "../../components/dynamics/useDynamicComponent";

export function AssistanceCreate() {
    const MainContent = useDynamicComponent("AssistanceWorkshopCreate");

    return (
        <Layout>
            <div className="pageContainer">
                <div className="pageHeader">
                    <PageTitle title={`Nova Assistência`} allowGoBack={true} />
                </div>

                <div className="pageBody">{MainContent}</div>
            </div>
        </Layout>
    );
}
